module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.47 10.161\"><path id=\"パス_2217\" data-name=\"パス 2217\" d=\"M2733.492,1597.406v5.561a.491.491,0,0,1-.491.491h-9.489a.49.49,0,0,1-.49-.491v-8.179a.49.49,0,0,1,.49-.491h2.291a.491.491,0,0,1,.491.491v4.014l2.845-1.81a.491.491,0,0,1,.754.414v1.4l2.845-1.81A.491.491,0,0,1,2733.492,1597.406Z\" transform=\"translate(-2722.522 -1593.797)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/order.svg
// module id = eqoC
// module chunks = 1